<template>
  <!--  Used for sports and recreation vehicles -->
  <div class="component-container">
    <h2 class="text-center">{{ $store.getters['trade/getVehicleName'] }}</h2>
    <p class="lead-text text-center mb-5">{{ $t('message.trade.infoForm.leadTextSports&Recreation') }}</p>
    <PersonalInfoForm
      :buttonLabelKey="buttonLabelKey"
      :foot-note-key="'message.trade.buttonInfoSportsAndRecreation'"
      @FormIsValid="continueForm"
      :av-errors="avErrors"
      :hide-mileage="true"
      ref="personalInfoForm"
    ></PersonalInfoForm>
  </div>
</template>

<script>
import { avErrorMixin, tradePersonalInfoMixin } from '@/mixins';
import { AVRProducts } from '@/utils/enums';
import PersonalInfoForm from '../../components/trade-in/PersonalInfoForm.vue';

export default {
  data() {
    return {};
  },
  mixins: [avErrorMixin, tradePersonalInfoMixin],
  components: { PersonalInfoForm },
  computed: {
    buttonLabelKey() {
      if (this.getCurrentProduct === AVRProducts.ACQUIRE) {
        return this.getPhoneNumberVerificationArray.acquire ? 'common.continue' : 'common.submit';
      }
      return this.getPhoneNumberVerificationArray.trade ? 'common.continue' : 'common.submit';
    },
  },
  methods: {
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      await this.processPersonalInfo(true);
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';

h2 {
  font-size: 28px;
  font-weight: bold;
}

.lead-text {
  font-size: 20px;
  font-weight: normal;
  color: #19222b;
}

.component-container ::v-deep form > div {
  width: 75%;
}

@media (max-width: $breakpoint-mobile) {
  .component-container ::v-deep form > div {
    width: 100%;
  }
}
</style>
